import betslip from '@gin-betting/betslip';
import core, { GQL, View } from '@gin-betting/core';
import { Set } from 'immutable';
import { createSelector } from 'reselect';

import { SELECTOR_STUB } from 'app-constants';
import type { Modules } from 'async-modules';

const {
    selectors: { selectBetslipBet, selectBetslipOdds },
} = betslip;
const {
    entities: {
        selectors: { selectBets },
    },
} = core;

export const selectFirstBetslipOdd = createSelector(
    selectBetslipBet,
    selectBetslipOdds,
    (betslipBet, betslipOdds) => {
        if (!betslipBet) return;

        const betslipOddId = betslipBet.betslipOddIds.first<undefined>();

        if (!betslipOddId) return;

        return betslipOdds.get(betslipOddId);
    }
);

export const selectBetByFirstBetslipOdd = createSelector(
    selectFirstBetslipOdd,
    selectBets,
    (betslipOdd, bets): undefined | View.Bet => {
        if (!betslipOdd) return;

        const { betId } = betslipOdd;

        if (!betId) return;

        return bets.get(betId);
    }
);

export const makeSelectIsFreebet = (
    freebetModule: Modules['freebet']['default'] | null
) => {
    const selectBetslipFreebets =
        freebetModule?.selectors.selectBetslipFreebets ?? SELECTOR_STUB;

    return createSelector(
        selectBetslipBet,
        selectBetslipFreebets,
        (betslipBet, betslipFreebets): boolean => {
            if (!betslipBet || !betslipFreebets) return false;

            const { mode, betslipOddIds } = betslipBet;

            if (mode === GQL.BetType.SINGLE) {
                return betslipOddIds.some(betslipOddId => {
                    const betslipFreebetId = Set([betslipOddId]);

                    const betslipFreebet = betslipFreebets.get(
                        betslipFreebetId
                    );

                    return !!betslipFreebet?.activeFreebetId;
                });
            }

            const betslipFreebet = betslipFreebets.get(betslipOddIds.toSet());

            return !!betslipFreebet?.activeFreebetId;
        }
    );
};
